import React from "react";
import { Chip, useTheme } from "@mui/material";

interface StatusChipProps {
    label: string;
    color: "red" | "green" | "amber" | "blue" | "default" | 'violet';
    variant?: "filled" | "outlined";
    size?: "small" | "medium";
    sx?: object;
}

export const StatusChip: React.FC<StatusChipProps> = ({
    label,
    color,
    variant = "outlined",
    size = "small",
    sx,
}) => {

    const theme = useTheme();

    const colorMap = {
        red: theme.palette.error.main,
        green: theme.palette.success.main,
        amber: theme.palette.warning.main,
        blue: theme.palette.info.main,
        default: theme.palette.text.secondary,
        violet: theme.palette.secondary.main,
        grey: theme.palette.grey[500],
    };

    const textColor = variant === "filled" ? colorMap[color] ? theme.palette.success.contrastText : theme.palette.text.primary
        : colorMap[color] || theme.palette.text.primary;

    const backgroundColor =
        variant === "filled" ? colorMap[color] : "transparent";

    const borderColor = colorMap[color] || 'transparent';

    return (
        <Chip
            label={label || 'N/A'}
            size={size}
            variant={variant}
            sx={{
                color: textColor,
                backgroundColor,
                borderColor,
                borderRadius: 5,
                textTransform: "capitalize",
                ...sx,
            }}
        />
    );
};